import * as React from 'react';
import { ModalProps } from '../../modal';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { classes, style } from 'typestyle';
import { px } from 'csx';
import { ComponentProps, deps, inject, observer } from '../../../lib/component';
import { rebrand } from '../../../theme/color';
import { Button } from '../atoms/button/Button';
import { ButtonProminence, ButtonSize } from '../atoms/button/buttonStyles';
import { ACCOUNT_PLANS_ROUTE } from '../../../constants';

const styles = {
  wrapper: style({
    display: 'block',
    maxWidth: px(550),
  }),
  heading: style({
    fontSize: px(32),
  }),
  body: style(ScrollableOverlayBodyStyle, {
    padding: '1.5rem 0 0',
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    textAlign: 'center',
    $nest: {
      '& > p': {
        margin: '0 0 1.5rem',
        fontSize: px(20),
        fontWeight: 700,
      },
    },
  }),
  button: style({
    display: 'block',
    width: '100%',
  }),
  banner: style({
    fontSize: px(20),
  }),
  contactLink: style({
    textDecoration: 'underline',
  }),
};

export type ReferralOfferModalProps = ModalProps & { className?: string };

/** A promo modal shown to unsubscribed, lapsed users coming into the app via a referral link */
export const ReferralOfferModal: React.FC<ReferralOfferModalProps & ComponentProps> = inject(deps)(
  observer(
    ({
      show,
      onRequestClose,
      model: {
        user: { user },
      },
      controller: {
        analytics: { sendMixpanel },
      },
    }) => {
      if (!user) return null;

      const handleCtaClick = () => {
        sendMixpanel('User clicks CTA button in referral offer modal');
        onRequestClose();
      };

      return (
        <ScrollableOverlay
          className={styles.wrapper}
          show={show}
          onRequestClose={onRequestClose}
          data-test-referral-offer-modal
        >
          <div className={overlayStyles.header}>
            <h3 className={classes(overlayStyles.title, styles.heading)}>Good to have you back!</h3>
          </div>

          <div className={styles.body}>
            <p>Claim your special referral offer on the plans page of your account</p>

            <div>
              <Button
                prominence={ButtonProminence.PRIMARY}
                size={ButtonSize.LARGE}
                className={styles.button}
                href={ACCOUNT_PLANS_ROUTE}
                onClick={handleCtaClick}
                data-test-referral-offer-modal-cta
              >
                Take me there
              </Button>
            </div>
          </div>
        </ScrollableOverlay>
      );
    }
  )
);
